import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loading: false,
  loadingLive: false,
  loadingScheduled: false,
  loadingDeactivated: false,
  loadingDraft: false,
  liveBanners: [],
  scheduledBanners: [],
  deactivatedBanners: [],
  draftBanners: [],
  paginationLive: {
    total: 0,
    limit: 10,
    page: 1,
  },
  paginationScheduled: {
    total: 0,
    limit: 10,
    page: 1,
  },
  paginationDeactivated: {
    total: 0,
    limit: 10,
    page: 1,
  },
  paginationDraft: {
    total: 0,
    limit: 10,
    page: 1,
  },
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    SET_LOADING(s, data) {
      s.loading = data;
    },
    SET_LOADING_LIVE(s, data) {
      s.loadingLive = data;
    },
    SET_LOADING_SCHEDULED(s, data) {
      s.loadingScheduled = data;
    },
    SET_LOADING_DEACTIVATED(s, data) {
      s.loadingDeactivated = data;
    },
    SET_LOADING_DRAFT(s, data) {
      s.loadingDraft = data;
    },
    SET_BANNERS_LIVE(s, data) {
      s.liveBanners = data;
    },
    SET_BANNERS_SCHEDULED(s, data) {
      s.scheduledBanners = data;
    },
    SET_BANNERS_DEACTIVATED(s, data) {
      s.deactivatedBanners = data;
    },
    SET_BANNERS_DRAFT(s, data) {
      s.draftBanners = data;
    },
    SET_PAGINATION_LIVE(s, data) {
      s.paginationLive = data;
    },
    SET_PAGINATION_SCHEDULED(s, data) {
      s.paginationScheduled = data;
    },
    SET_PAGINATION_DEACTIVATED(s, data) {
      s.paginationDeactivated = data;
    },
    SET_PAGINATION_DRAFT(s, data) {
      s.paginationDraft = data;
    },
  },

  actions: {
    async getLiveBanners({ commit }, params) {
      try {
        commit("SET_LOADING_LIVE", true);
        const { data: res } = await this.$api.get(`/v1/portal/banner`, {
          params: {
            ...params,
            type: "now",
            status: 1,
          },
        });
        commit("SET_BANNERS_LIVE", res.data);
        commit("SET_PAGINATION_LIVE", res.pagination);
      } catch (e) {
      } finally {
        commit("SET_LOADING_LIVE", false);
      }
    },
    async getScheduledBanners({ commit }, params) {
      try {
        commit("SET_LOADING_SCHEDULED", true);
        const { data: res } = await this.$api.get(`/v1/portal/banner`, {
          params: {
            ...params,
            type: "upcoming",
          },
        });
        commit("SET_BANNERS_SCHEDULED", res.data);
        commit("SET_PAGINATION_SCHEDULED", res.pagination);
      } catch (e) {
      } finally {
        commit("SET_LOADING_SCHEDULED", false);
      }
    },
    async getDeactivatedBanners({ commit }, params) {
      try {
        commit("SET_LOADING_DEACTIVATED", true);
        const { data: res } = await this.$api.get(`/v1/portal/banner`, {
          params: {
            ...params,
            type: "ended",
            status: 1,
          },
        });
        commit("SET_BANNERS_DEACTIVATED", res.data);
        commit("SET_PAGINATION_DEACTIVATED", res.pagination);
      } catch (e) {
      } finally {
        commit("SET_LOADING_DEACTIVATED", false);
      }
    },
    async getDraftBanners({ commit }, params) {
      try {
        commit("SET_LOADING_DRAFT", true);
        const { data: res } = await this.$api.get(`/v1/portal/banner`, {
          params: {
            ...params,
            status: 3,
          },
        });
        commit("SET_BANNERS_DRAFT", res.data);
        commit("SET_PAGINATION_DRAFT", res.pagination);
      } catch (e) {
      } finally {
        commit("SET_LOADING_DRAFT", false);
      }
    },
    async getBannerDetail({ commit }, id) {
      try {
        const { data: res } = await this.$api.get(`/v1/portal/banner/${id}`);
        return res.data;
      } catch (e) {
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async createBanner({ commit, dispatch }, payload) {
      try {
        commit("SET_LOADING", true);
        const { data: res } = await this.$api.post(
          `/v1/portal/banner`,
          payload
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async updateBanner({ dispatch }, { bannerId, data }) {
      try {
        const { data: res } = await this.$api.put(
          `/v1/portal/banner/${bannerId}`,
          data
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async deleteBannerImage({ dispatch }, { bannerId, resourceId }) {
      try {
        const { data: res } = await this.$api.delete(
          `/v1/portal/banner/${bannerId}/resource/${resourceId}`
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },

    async updateBanner({ dispatch }, { bannerId, data }) {
      try {
        const { data: res } = await this.$api.put(
          `/v1/portal/banner/${bannerId}`,
          data
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },

    async uploadBannerImage({ commit }, banner) {
      try {
        const formData = new FormData();
        formData.append("banner", banner.file);
        const { data: res } = await this.$api.post(
          `/v1/portal/banner/upload`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
        throw e;
      }
    },
    async orderBanners({}, payload) {
      try {
        const { data: res } = await this.$api.put(
          "/v1/portal/banner/update/order",
          payload
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async addBannerTargets({ commit }, payload) {
      try {
        const { bannerId, targets } = payload;
        const { data: res } = await this.$api.post(
          `/v1/portal/banner/${bannerId}/targets`,
          { targets }
        );
        if (res.data) return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async deleteBannerTargets({ commit }, ids) {
      try {
        const { data: res } = await this.$api.delete(
          `/v1/portal/banner/targets?bannerTargetIds=${ids}`
        );
        if (res.data) return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
  },
};
